import RefereeQuestion from './RefereeQuestion';
import Option from '../Option';
import { pref, cref } from '../../core/constants';

export default interface ReferenceTemplate {
	id?: string;
	clientCustomerId?: number;
	subCustomerId?: number;
	name?: string;
	workflowTypeCode: keyof typeof referenceWorkflowTypeCodesToTypes;
	refereeQuestions?: RefereeQuestion[];
}

// This is also known as the ReferenceDefinition.WorkflowServiceName values.
export const referenceWorkflowTypeCodesToTypes = {
	AREF: 'Agency Reference',
	EDREF: 'Education Reference',
	EREF: 'Employment Reference',
	[pref]: 'Personal Reference',
	SEREF: 'Self Employed Reference',
	[cref]: 'Career Break'
};

export const getReferenceTemplateType = (referenceTemplate: ReferenceTemplate) => {
	return referenceWorkflowTypeCodesToTypes[referenceTemplate.workflowTypeCode];
};

export const getReferenceWorkflowTypeCodeOptions = (): Option<string>[] => {
	return Object.entries(referenceWorkflowTypeCodesToTypes)
		.filter(([workflowTypeCode]) => workflowTypeCode !== cref)
		.map(([workflowTypeCode, type]) => ({
			text: type,
			value: workflowTypeCode
		}));
};
